module.exports = __webpack_public_path__ + "img/rechnung-data.9f5b728d.svg";